import {matchSurvey, isSurveyExpired} from './helpers';
import {InternalFeedbackBanner} from './internal-feedback-banner';

export function InternalFeedbackBannerWrapper() {
    const pathname = window.location.pathname;
    const survey = matchSurvey(pathname);

    if (!survey) {
        return null;
    }

    if (isSurveyExpired(survey.expireDate)) {
        return null;
    }

    return <InternalFeedbackBanner survey={survey} />;
}
